import { createSlice } from '@reduxjs/toolkit';
import { UserEventLog } from '../../services/api/userEventLogService';
import { fetchMyEvents, fetchAllEvents } from '../thunks/userEventLogThunks';

export interface UserEventLogState {
  // My events (myinfo page)
  myLogs: UserEventLog[];
  myTotalCount: number;
  myPageNumber: number;
  myPageSize: number;
  myIsLoading: boolean;
  myError: string | null;

  // Admin all events
  adminLogs: UserEventLog[];
  adminTotalCount: number;
  adminPageNumber: number;
  adminPageSize: number;
  adminIsLoading: boolean;
  adminError: string | null;
}

const initialState: UserEventLogState = {
  myLogs: [],
  myTotalCount: 0,
  myPageNumber: 1,
  myPageSize: 20,
  myIsLoading: false,
  myError: null,

  adminLogs: [],
  adminTotalCount: 0,
  adminPageNumber: 1,
  adminPageSize: 20,
  adminIsLoading: false,
  adminError: null,
};

const userEventLogSlice = createSlice({
  name: 'userEventLog',
  initialState,
  reducers: {
    resetMyLogs: (state) => {
      state.myLogs = [];
      state.myTotalCount = 0;
      state.myPageNumber = 1;
      state.myError = null;
    },
    resetAdminLogs: (state) => {
      state.adminLogs = [];
      state.adminTotalCount = 0;
      state.adminPageNumber = 1;
      state.adminError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyEvents.pending, (state) => {
        state.myIsLoading = true;
        state.myError = null;
      })
      .addCase(fetchMyEvents.fulfilled, (state, action) => {
        state.myIsLoading = false;
        state.myLogs = action.payload.logs;
        state.myTotalCount = action.payload.totalCount;
        state.myPageNumber = action.payload.pageNumber;
        state.myPageSize = action.payload.pageSize;
      })
      .addCase(fetchMyEvents.rejected, (state, action) => {
        state.myIsLoading = false;
        state.myError = action.payload as string;
      });

    builder
      .addCase(fetchAllEvents.pending, (state) => {
        state.adminIsLoading = true;
        state.adminError = null;
      })
      .addCase(fetchAllEvents.fulfilled, (state, action) => {
        state.adminIsLoading = false;
        state.adminLogs = action.payload.logs;
        state.adminTotalCount = action.payload.totalCount;
        state.adminPageNumber = action.payload.pageNumber;
        state.adminPageSize = action.payload.pageSize;
      })
      .addCase(fetchAllEvents.rejected, (state, action) => {
        state.adminIsLoading = false;
        state.adminError = action.payload as string;
      });
  },
});

export const { resetMyLogs, resetAdminLogs } = userEventLogSlice.actions;
export default userEventLogSlice.reducer;
